/* eslint-disable import/prefer-default-export */
import { z } from 'zod';

export const buildOrderSchema = (t, shippingCostMethod = null) => z
  .object({
    customer: z.object({
      first_name: z.string().min(1, t("errors.required")),
      last_name: z.string().min(1, t("errors.required")),

      email: z
        .string()
        .email(t("errors.invalid_email"))
        .optional()
        .or(z.literal('').transform(() => undefined)),

      phone: z
        .union([z.string(), z.null()])
        .transform((val) => (val === '' ? undefined : val))
        .refine(
          (val) => !val || (typeof val === 'string' && val.includes('*')) || /^\+?\d+$/.test(val),
          { message: t("errors.invalid_phone") }
        )
        .optional(),

      country_id: z.string().optional(),
      id_in_mercately: z.union([z.string(), z.number()]).optional(),
      web_id_in_mercately: z.string().optional()
    }),
    delivery_method: z.string().min(1, t("errors.select_delivery_method")),
    shipping_cost_id: z.union([z.string(), z.literal(''), z.null()]).optional(),
    shipping_value: z.union([z.string(), z.literal(''), z.null()]).optional(),
    orderAddress: z.string().min(1, t("errors.required")),
    currency: z.string().min(1, t("errors.required")),
    status: z.string().min(1, t("errors.required")),
    agent_id: z.string().nullable().refine(
      (val) => val !== null && val !== '',
      { message: t("errors.required") }
    ),
    sales_channel_id: z.coerce.string().min(1, t("errors.required"))
  })
  .refine(
    (data) =>
      data.customer.email ||
      data.customer.phone ||
      (data.customer.id_in_mercately || data.customer.web_id_in_mercately),
    {
      message: t("errors.email_or_phone"),
      path: ["customer", "email"]
    }
  )
  .refine(
    (data) => {
      // Si tiene phone y no está enmascarado, country_id debe estar presente
      const phone = data.customer.phone;
      if (phone && typeof phone === 'string' && !phone.includes('*')) {
        return data.customer.country_id && data.customer.country_id.length > 0;
      }
      // Si no tiene email pero no tiene phone tampoco, country_id no es requerido
      // La validación de email OR phone es manejada por el otro refine
      return true;
    },
    {
      message: t("errors.required"),
      path: ["customer", "country_id"]
    }
  )
  .refine(
    (data) => {
      // Si el método de entrega es send_order y el método de costo es location_cost,
      // entonces shipping_cost_id debe tener valor
      if (data.delivery_method === 'send_order' && shippingCostMethod === 'location_cost') {
        return data.shipping_cost_id && String(data.shipping_cost_id).length > 0;
      }
      return true;
    },
    {
      message: t("errors.required"),
      path: ["shipping_cost_id"]
    }
  )
  .refine(
    (data) => {
      // Si el método de entrega es send_order, entonces shipping_value debe tener valor
      if (data.delivery_method === 'send_order') {
        return data.shipping_value && String(data.shipping_value).length > 0;
      }
      return true;
    },
    {
      message: t("errors.required"),
      path: ["shipping_value"]
    }
  );
